export default [
    {
      header: 'Surveys',
      title: 'Surveys',
      icon: 'Edit2Icon',
      route: 'surveys-list',
      resource: 'AdminAccess',
    },
  ]
  